(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if(recommendations && recommendations.innerHTML.trim().length){
            this.innerHTML = recommendations.innerHTML;
          }
          if(html.querySelector('.grid__item')){
            this.classList.add('product-recommendations--loaded');
          }
          
          document.querySelectorAll('.product-carousel').forEach(function(Element,index){
            let productid = Element.dataset.id;
            let outer_carousel = Element.closest('.carousel-rowouter');
            let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
            let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
            let swiper = new Swiper(Element,{
              loop:eval(Element.dataset.loop),
              slidesPerView: "auto",
              navigation: {
                nextEl:nextbutton,
                prevEl:prevbutton,
              },
              a11y: false,
            })
            if(document.querySelectorAll('.prod-caro-tab li')){
              document.querySelectorAll('.prod-caro-tab li').forEach((tab) =>{
                let currentVal = tab.getAttribute('data-title');
                if(Element.closest('.carousel-rowouter').getAttribute('data-title') == currentVal){
                  tab.addEventListener('click',function(e){
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    let tabsWithIsOpen = document.querySelectorAll(".prod-caro-tab li.active-tab");
                    tabsWithIsOpen.forEach((tabWithIsOpen) => {
                      tabWithIsOpen.classList.remove("active-tab");
                    });
                    tab.classList.add("active-tab");
                    let currentCarousel = Element.closest('.carousel-rowouter').getAttribute('data-title');
                    if(currentVal == currentCarousel){
                      let carouselsWithIsOpen = document.querySelectorAll(".carousel-rowouter.active-carousel");
                      carouselsWithIsOpen.forEach((carouselWithIsOpen) => {
                        carouselWithIsOpen.classList.remove("active-carousel");
                      });
                      Element.closest('.carousel-rowouter').classList.add("active-carousel");
                    }
                    document.querySelectorAll('.product-carousel-main .prod-caro-btns').forEach((btns) =>{
                      btns.querySelectorAll('li').forEach((btn) =>{
                        let currentBtn = btn.getAttribute('data-title');
                        if(currentVal == currentBtn){
                          let btnsWithIsOpen = btns.querySelectorAll("li.active-btn");
                          btnsWithIsOpen.forEach((btnWithIsOpen) => {
                            btnWithIsOpen.classList.remove("active-btn");
                          });
                          btn.classList.add("active-btn");
                        }
                      });
                    });
                    swiper.update();
                  });
                }
              });
            }
            document.querySelectorAll('.variant-grid').forEach(function(sizeList){
              sizeList.addEventListener('click',function(e){
                e.preventDefault();
                e.stopImmediatePropagation();
                let variant_id;
                sizeList.closest('.grid-size-variants').querySelectorAll('.variant-grid').forEach(function(removeActive){
                  removeActive.classList.remove('active');
                });
                sizeList.classList.add('active');
                let nextSibling = sizeList.closest('.grid-variant-outer-wrap').nextElementSibling;
                let prevSibling = sizeList.closest('.grid-variant-outer-wrap').previousElementSibling;
                if(nextSibling || prevSibling){
                  if(nextSibling) nextSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
                    if(!siblingList.classList.contains('active')){
                      return false;
                    }
                  })
                  if(prevSibling) prevSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
                    if(!siblingList.classList.contains('active')){
                      return false;
                    }
                  })
                  let combineValue = '';
                  let count = 0;
                  sizeList.closest('.grid-variant-outer').querySelectorAll('.variant-grid.active').forEach((activeValue) => {
                    count++;
                    if(combineValue == ''){
                      combineValue = activeValue.getAttribute('data-title')
                    }else{
                      combineValue = combineValue + ' / ' + activeValue.getAttribute('data-title')
                    }
                  })
                  sizeList.closest('.grid-imagebox').querySelectorAll('.combine-variant-detail li').forEach((finalList) => {
                    let title = finalList.getAttribute('data-title');
                    if(title == combineValue){
                      variant_id = finalList.dataset.id;
                    }
                  })
                }else{
                  variant_id = sizeList.dataset.id;
                }
                if(variant_id != undefined){
                  let error_grid_outer = sizeList.closest('.snippet-product-grid');
                  let error_grid = error_grid_outer.querySelector('.grid-error');
                  let formData = {
                    'items': [{
                      'id': variant_id,
                      'quantity': 1
                    }]
                  };
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                  })
                  .then((response) => response.json())
                  .then((data) => {
                    if(data.status == 422)
                    {
                      error_grid.innerHTML = data.description;
                      setTimeout(function(e){
                        error_grid.innerHTML = '';
                      },2000);
                    }else{          
                      if(document.location.href.indexOf('/cart') > -1) {
                        window.location.href = "/cart";
                      }else{
                        if(typeof load_cart == 'function'){
                          // cartNotification(response.items[0].id);
                          load_cart();
                          setTimeout(function(e){
                            document.querySelector('body').classList.remove('stickybar');
                            document.querySelector('body').classList.add('open-drawer');
                          },500);
                        }else{
                          window.location.href = "/cart";
                        }          
                      }
                      const url = '/cart.js';
                      fetch(url)
                      .then((resp) => resp.json())
                      .then(function(data) {
                        var cart_count = data.item_count;
                        if(cart_count>0){
                          document.querySelector('.cart-count').innerHTML = cart_count;
                        }else{
                          document.querySelector('.cart-count').innerHTML = '';
                        }
                      })
                      .catch(function(error) {
                        console.log(error);
                      })
                    }
                    gtag("event", "add_to_cart", {
                      currency: Shopify.currency.active,
                      value: data.items[0].price,
                      items: [
                        {
                          item_id: data.items[0].product_id,
                          item_name: data.items[0].product_title,
                          affiliation: "Google Merchandise Store",
                          discount: data.items[0].price - (data.items[0].price * 0.10),
                          index: 0,
                          item_brand: data.items[0].product_type,
                          item_list_id: "related_products",
                          item_list_name: "Related Products",
                          item_variant: data.items[0].variant_title,
                          price: data.items[0].price,
                          quantity: data.items[0].quantity
                        }
                      ]
                    });
                  })
                  .catch((error) => {
                    console.error(error);
                  });
                }
              });
            });
            document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
              quickBtn.addEventListener('click',function(e){
                e.preventDefault();
                e.stopImmediatePropagation();
                let url = quickBtn.getAttribute('data-url');
                let modal = quickBtn.getAttribute('data-modal');
                fetch(url)
                .then((response) => response.text())
                .then((response) => {
                  const html = new DOMParser().parseFromString(response, 'text/html');
                  const source = html.getElementById('section-quick-buy');
                  document.querySelector('body').classList.add('open-quick-buy');
                  document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
                  addToCart();

                      document.querySelector('.quick-buy-add').addEventListener('click',function(evt){
                        evt.preventDefault();
                        let variant_id = evt.target.closest('form').querySelector('input[name="id"]').getAttribute('value');
                        let qty = document.querySelector('.quantity__input').value;
                        let formData = {
                          'items': [{
                            'id': variant_id,
                            'quantity': qty
                          }]
                        };
                        fetch('/cart/add.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify(formData),
                        })
                        .then((response) => response.json())
                        .then((response) => {      
                          if (response.status) {
                            document.querySelector('.product-form-error').innerHTML = response.description;
                            setTimeout(function(e){
                              document.querySelector('.product-form-error').innerHTML  = '';
                            },2000);
                            return;
                          }else{
                            if(typeof load_cart == 'function'){
                              cartNotification(response.items[0].id);
                              load_cart();
                              if(window.outerWidth > 991){
                                setTimeout(function(e){
                                  document.querySelector('body').classList.add('open-drawer');
                                },500);
                              }else{
                                cartNotification(response.items[0].id);
                                document.querySelector('.quick-buy-popup').innerHTML = '';
                              }
                            }else{
                              window.location.href = "/cart";
                            }
                          }
                          document.querySelector('.added-cart').style.display = 'flex';
                          document.querySelector('.p-add-cart-btn').style.display = 'none';
                          setTimeout(function(e){
                            document.querySelector('.added-cart').style.display = 'none';
                            document.querySelector('.p-add-cart-btn').style.display = 'flex';
                          },2000);
                        })
                        .catch((e) => {console.error(e);})
                        .finally(() => {});
                      });
                  
                })
                .catch((e) => {console.error(e);})
              })
            })
          });
        })
        .catch(e => {console.error(e);});
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
